import React from 'react';
import { Form } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import { getYearsAsStrings, countries, counties, occupations } from '../../../../../../common/utils/data';

const Mentor = (props) => {
  const { data, t } = props;
  
  return (
    <div>
      <p>
        {t('private:addTeam.mentor.text')}
      </p>
      <Form.Group widths='equal'>
        <Form.Input
          width={6}
          required
          label={t('common:auth.given_name')}
          name='given_name'
          value={data.given_name}
          onChange={props.onChange}
        />
        <Form.Input
          width={6}
          required
          label={t('common:auth.family_name')}
          name='family_name'
          value={data.family_name}
          onChange={props.onChange}
        />
        <Form.Dropdown
          width={4}
          fluid
          search
          selection
          required
          label={t('common:auth.custom:year_of_birth')}
          name='custom:year_of_birth'
          value={data['custom:year_of_birth']}
          options= {getYearsAsStrings()}
          onChange={props.onChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Input
          width={6}
          required
          label={t('common:auth.custom:phone_number')}
          name='custom:phone_number'
          value={data['custom:phone_number']}
          onChange={props.onChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Dropdown
          width={6}
          fluid
          search
          selection
          required
          label={t('common:auth.custom:occupation')}
          name='custom:occupation'
          value={data['custom:occupation']}
          options={occupations}
          onChange={props.onChange}
        />
        <Form.Input
          width={10}
          required
          label={t('common:auth.custom:occupation_details')}
          name='custom:occupation_details'
          value={data['custom:occupation_details']}
          onChange={props.onChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Dropdown
          width={6}
          required
          label={t('common:auth.custom:country_of_residence')}
          fluid
          search
          selection
          value={data['custom:country_of_residence']}
          name='custom:country_of_residence'
          options={countries}
          onChange={props.onChange}
        />
        {
          data['custom:country_of_residence'] === 'ee' &&
            <Form.Dropdown
              width={10}
              required={true}
              label={t('common:auth.custom:county_of_residence')}
              fluid
              search
              selection
              value={data['custom:county_of_residence']}
              name='custom:county_of_residence'
              options={counties}
              onChange={props.onChange}
            />
        }
      </Form.Group>
    </div>
  );
};

export default withNamespaces(['common', 'private'])(Mentor);




// WEBPACK FOOTER //
// ./src/private/common/components/Team/Form/Mentor/index.js